module.exports = __webpack_public_path__ + "static/media/05660005-rPSzwSgs.f8353fc7.JPG";